/**
 * quotaStore — sinaliza globalmente quando o usuário esbarra num limite
 * (storage cheio, projetos cheios) pra abrir o BillingQuickPanel pré-
 * selecionado no item certo, em qualquer lugar da UI.
 *
 * Funciona como um event bus minimalista — qualquer hook/componente pode
 * disparar `openStorageNudge(bytesNeeded)` e o nudge aparece, mesmo se
 * o componente que disparou for desmontado em seguida (ex: upload modal
 * que fecha após erro).
 */
import { create } from 'zustand';

export interface QuotaState {
  /** True quando o painel de "limite atingido" deve aparecer. */
  open: boolean;
  /** Bytes a mais que o usuário precisaria pra completar a ação. */
  bytesNeeded: number;
  /** Mensagem custom opcional (ex: "Esse vídeo não cabe no plano Free"). */
  reason?: string;

  /** Abre o painel; bytesNeeded ajuda a sugerir o pack certo. */
  openStorageNudge: (bytesNeeded: number, reason?: string) => void;
  close: () => void;
}

export const useQuotaStore = create<QuotaState>((set) => ({
  open: false,
  bytesNeeded: 0,
  reason: undefined,
  openStorageNudge: (bytesNeeded, reason) =>
    set({ open: true, bytesNeeded, reason }),
  close: () => set({ open: false, bytesNeeded: 0, reason: undefined }),
}));
